/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { CircularProgress, Paper, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Tooltip, IconButton, Breadcrumbs } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'

import FieldIcon from '../Fields/FieldIcon'

import GlobalFieldSelect from '../UtilComps/GlobalFieldSelect'

import Actions from '../../../../../fluid/Actions/ActionFactory'
import SingletonIcon from '../Singletons/SingletonIcon'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    },
    headerStyle : {
        color : '#707070',
        backgroundColor : '#F5F5F5',
        fontSize : 11,
        border : 'none'
    },
    statsStatic: {
        width : '100%',
        height : '150px',
        display : 'flex',
        flexDirection : 'column',
        alignItems : 'center'
    },
    statsAnimatedLeft: {
        width : '100%',
        height : '150px',
        display : 'flex',
        flexDirection : 'column',
        alignItems : 'flex-start',
        // animationName : '$fieldNameSlideLeft',
        // animationDuration : '0.5s',
        // animationFillMode : 'forwards',
    },
    statsAnimatedRight: {
        width : '100%',
        height : '150px',
        display : 'flex',
        flexDirection : 'column',
        alignItems : 'flex-end',
        // animationName : '$fieldNameSlideRight',
        // animationDuration : '0.5s',
        // animationFillMode : 'forwards',
    },
    '@keyframes fieldNameSlideRight' : {
        from : {alignItems: 'center'},
        to : {alignItems : 'flex-end'}
    },
    '@keyframes fieldNameSlideLeft' : {
        from : {alignItems: 'center'},
        to : {alignItems : 'flex-start'}
    },
    tableTextAnimated : {
        animationName : '$tableTextSlideRight',
        animationDuration : '0.5s',
        animationFillMode : 'forwards',
    },
    '@keyframes tableTextSlideRight' : {
        from : {transform : 'translate(0, 0)'},
        to : {transform : 'translate(50%, 0)'}
    },
    // tableContainerStatic : {
    //     maxHeight : props => (props.body_height - 180) + "px",
    // },
    // tableContainerAnimatedRight : {
    //     maxHeight : props => (props.body_height - 180) + "px",
    //     animationName : '$tableSlideRight',
    //     animationDuration : '0.5s',
    //     animationFillMode : 'forwards'
    // },
    // tableContainerAnimatedLeft : {
    //     maxHeight : props => (props.body_height - 180) + "px",
    //     overflowX : 'auto'
    // },
    '@keyframes tableSlideRight' : {
        from : {
            transform : 'translate(0, 0)',
        },
        to : {
            transform : 'translate(100%, 0)',
        }
    },
    tableContainerDiv : {
        width : '100%',
        height : props => (props.body_height - 150) + "px",
        padding : '10px',
        overflow : 'auto'
    },
    tableContainerDivRight : {
        width : '50%',
        height : props => (props.body_height - 150) + "px",
        padding : '10px',
        overflow : 'auto',
        transform : 'translate(100%, 0)',
        // animationName : '$tableSlideRight',
        // animationDuration : '0.5s',
        // animationFillMode : 'forwards'
    },
    tableContainerDivLeft : {
        width : '50%',
        height : props => (props.body_height - 150) + "px",
        padding : '10px',
        overflow : 'auto'
    }
})

class FieldDetail extends Component {
    state = {
        statistics : null,
        loading_statistics : false,
        loading_stats_error : false
    }

    componentDidUpdate (prevProps) {
        var equal = require('fast-deep-equal');
        if (!equal(this.props.field_in_focus, prevProps.field_in_focus)) {
            this.setState({
                ...this.state,
                statistics : null,
                loading_statistics : false,
                loading_stats_error : false
            })
        }
    }

    getAnimationDirection = () => {
        if (this.props.checking_field_similarity) { 
            let my_column_index = this.props.field_similarity_col_indices.findIndex(index => index === this.props.column_index)
            if (my_column_index === 1) {
                console.log("IFC :: Animate Right")
                return 'right'
            } else {
                console.log("IFC :: Animate left")
                return 'left'
            }
        } else {
            return null
        }
    }

    renderNavigation = () => {
        return (
            <Paper 
                variant = 'outlined'
                square
                style = {{
                    width : '100%',
                    height : '50px',
                    display : 'flex',
                    flexDirection : 'row'
                }}
            >
                <div style = {{
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    justifyContent : 'center'
                }}>
                    <Tooltip title = "Back to groups">
                        <IconButton size = 'small' color = 'primary' onClick = {() => this.props.unfocus_field()}>
                            <ArrowBack fontSize = 'inherit'/>
                        </IconButton>
                    </Tooltip>
                </div>
                <div style = {{
                    display : 'flex',
                    flexDirection : 'row-reverse',
                    alignItems : 'center',
                    flexGrow : 1,
                    padding : '10px'
                }}>
                    <Breadcrumbs>
                        {this.props.from.split("/").map(loc => {
                            return (
                                <Typography variant = 'caption' color = 'textSecondary'>{loc}</Typography>
                            )
                        })}
                        <Typography variant = 'caption' color = 'primary'>{this.props.field_in_focus.field}</Typography>
                    </Breadcrumbs>
                </div>
            </Paper>
        )
    }

    renderMapField = () => {
        if (this.props.field_type === "singleton") {
            if (this.props.allow_mapping_global_field) {
                return (
                    <div
                        style = {{
                            width : '100%',
                            height : '65px',
                            borderBottom : '1px solid rgba(0,0,0,0.12)'
                        }}
                    >
                        <GlobalFieldSelect
                            ic_name = {this.props.ic_name}
                            version = {this.props.version}
                            global_field_display_name = {this.props.global_field_display_name} 
                            group_data = {this.props.field_in_focus} 
                            global_mapped_field = {this.props.field_in_focus.global_mapped_field} 
                            global_fields = {this.props.global_fields}
                            global_fields_error = {this.props.global_fields_error}
                            field_in_focus = {this.props.field_in_focus}
                            mapping_global_field = {this.props.mapping_global_field}
                            map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                            create_global_field = {(entity_id, new_field_name) => this.props.create_global_field(entity_id, new_field_name)}
                        />
                    </div>
                )
            }
        } else {
            return (
                <Paper
                    square
                    variant = 'outlined'
                    style = {{
                        width : '100%',
                        height : '65px'
                    }}
                ></Paper>
            )
        }
    }

    getStatistics = () => {
        this.setState({...this.state, loading_statistics : true, laoding_stats_error : false, statistics : null}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/statistics_for_fields",
                method : "post",
                data : {
                    fields : [this.props.field_in_focus.field],
                    ic_name : this.props.ic_name,
                    top_k : 10
                }
            }).then(res => {
                this.setState({...this.state, loading_statistics : false, laoding_stats_error : false, statistics : res.data.result.Result[0]})
            }).catch(err => {
                this.setState({...this.state, loading_statistics : false, laoding_stats_error : true, statistics : null})
            })
        })
    }

    renderStatistics = () => {
        if (this.state.loading_stats_error) {
            return this.renderStatsError()
        }

        if (this.state.statistics === null) {
            if (!this.state.loading_statistics) {
                this.getStatistics()
            } else {
                return this.renderStatsLoader()
            }
        } else {
            return this.renderStatisticsContent()
        }
    }

    renderStatsLoader = () => {
        return (
            <div
                style = {{
                    width : '100%', 
                    height : this.props.body_height + 'px', 
                    overflow : 'hidden',
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    justifyContent : 'center'
                }}
            >
                <CircularProgress vaiant = 'indeterminate' color = 'primary'/>
            </div>
        )
    }

    renderStatisticsContent = () => {
        const { classes } = this.props
        return (
            <div
                style = {{
                    width : '100%', 
                    height : this.props.body_height + 'px', 
                    overflow : 'hidden'
                }}
            >
                <Paper
                    square
                    variant = 'outlined'
                    className = {this.getAnimationDirection() === null ? classes.statsStatic : this.getAnimationDirection() === 'left' ? classes.statsAnimatedLeft : classes.statsAnimatedRight }
                >
                    <div
                        style = {{
                            height : '90px',
                            display :'flex',
                            padding : '10px',
                            flexDirection : 'row',
                            justifyContent : 'center',
                            alignItems : 'center'
                        }}
                    >
                        {this.props.field_type === "singleton" ? <SingletonIcon/> : <FieldIcon field_display_name = {this.props.field_display_name}/>}
                        <Typography 
                            style = {{
                                fontSize : 17,
                                fontWeight : 700,
                                marginLeft : '15px'
                            }} 
                            display = 'inline-block'
                            variant = 'subtitle2'
                        >
                            {this.props.field_in_focus.field}
                        </Typography>
                    </div>
                    <div
                        style = {{
                            height : '60px',
                            paddingLeft : '10px',
                            padding : '10px',
                        }}
                    >
                        <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography display = 'inline-block' variant = 'caption' color = 'textSecondary'>Total number of unique values :</Typography>
                            <Typography style = {{fontWeight : 700}} display = 'inline-block' variant = 'caption' color = 'primary'>{this.state.statistics.total_num_unique}</Typography>
                        </div>
                        <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography display = 'inline-block' variant = 'caption' color = 'textSecondary'>Percentage of empty entries :</Typography>
                            <Typography style = {{fontWeight : 700}} display = 'inline-block' variant = 'caption' color = 'primary'>{(this.state.statistics.empty * 100).toFixed(2) + "%"}</Typography>
                        </div>
                    </div>
                </Paper>
                {this.renderSampleValues()}
            </div>
        )
    }

    renderSampleValues = () => {
        const { classes } = this.props
        return (
            <div 
                className = {this.getAnimationDirection() === null ? classes.tableContainerDiv : this.getAnimationDirection() === 'left' ? classes.tableContainerDivLeft : classes.tableContainerDivRight}
            >
                <Typography display = 'block' variant = 'subtitle2'>Sample Unique Values</Typography>
                <TableContainer 
                    style = {{
                        width : 'calc(25vw - 20px)',
                        maxHeight : props => (props.body_height - 180) + "px",
                    }}
                >
                    <Table
                        style = {{
                            borderCollapse : 'separate',
                            borderSpacing : '0px 7px',
                            marginRight : '10px',
                        }}
                        stickyHeader
                    >
                        <TableHead>
                            <TableRow style = {{width : '90%', padding : '10px'}}>
                                <TableCell
                                    className = {classes.headerStyle}
                                    padding = 'none' 
                                    size = 'small'
                                >Value</TableCell>
                                <TableCell
                                    className = {classes.headerStyle}
                                    padding = 'none' 
                                    size = 'small'
                                    align = 'center'
                                >Frequency</TableCell>
                                <TableCell
                                    className = {classes.headerStyle}
                                    padding = 'none' 
                                    size = 'small'
                                    align = 'center'
                                >Score</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.statistics.unique_values.map((val, i) => {
                                return (
                                    <TableRow style = {{
                                        backgroundColor : '#FFFFFF',
                                        padding : '10px',
                                        boxShadow : '1px 2px 12px -9px rgba(0,0,0,0.49)',
                                        width : '90%',
                                    }}
                                    >
                                        <TableCell 
                                            style = {{ 
                                                border: 'none',
                                                fontSize : 12
                                            }}
                                        >{val}</TableCell>
                                        <TableCell
                                            align = 'center'
                                            style = {{ 
                                                border: 'none',
                                                fontSize : 12,
                                                fontWeight : 600,
                                                color : '#707070'
                                            }}
                                        >{this.state.statistics.frequency[i]}</TableCell>
                                        <TableCell 
                                            align = 'center'
                                            style = {{ 
                                                border: 'none',
                                                fontSize : 12,
                                                fontWeight : 900,
                                                color : '#03AD93'
                                            }}
                                        >{this.state.statistics.support[i].toFixed(2)}</TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }

    renderStatsError = () => {
        return (
            <div
                style = {{
                    width : '100%', 
                    height : this.props.body_height + 'px', 
                    overflow : 'hidden',
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    justifyContent : 'center'
                }}
            >
                <Typography variant = 'caption' color = 'secondary'>Error loading field statistics.</Typography>
                <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = 'primary' onClick = {() => this.getStatistics()}>Reload.</Typography>
            </div>
        )
    }

    render() { 
        return (
            <div style = {{width : '100%', height : this.props.body_height + "px", overflow : 'hidden'}}>
                {this.renderNavigation()}
                {this.renderMapField()}
                {this.renderStatistics()}
            </div>
        );
    }
}
 
export default withStyles(styles)(FieldDetail);